/**
 * Scrolls the first visible validation error into view (centered, smooth).
 *
 * Wizard errors render far from the "Continue" button — often at the top of the
 * form — so a blocked submit looked like nothing happened: the user clicks
 * Continue at the bottom and the error appears off-screen above. Call this on a
 * failed submit to take the user to the error.
 *
 * Targets `[role="alert"]`, which every wizard error message/container uses
 * (AppInput errors, step field errors, the platform-constraints block). Skips
 * fixed-position nodes (toasts) and defers a frame so freshly-set error nodes
 * are mounted before we look for them.
 */
export function scrollToFirstError(): void {
  requestAnimationFrame(() => {
    const candidates = document.querySelectorAll<HTMLElement>('[role="alert"]');
    for (const el of candidates) {
      // Toasts are role="alert" too, but they're fixed-position overlays —
      // scrolling to them is pointless. Skip them and find the in-form error.
      if (window.getComputedStyle(el).position === 'fixed') continue;
      el.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
  });
}
